import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { huntingtonBeachConfig } from "./data";

export default function HuntingtonBeachPage() {
  return <CityPageTemplate config={huntingtonBeachConfig} />;
}